/** Lot Biography — one lot's stock, movements, family, QC and seed status history. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { LotBiographyPage } from "@/features/inventory/lots/lot-biography-page";

export const Route = createFileRoute("/_app/warehouse/lot-biography/$lotId")({
  beforeLoad: () => {
    // Quality ▸ Lot Biography opens it for QA roles too (qc.lot_biography, 2026-10-16).
    const { can } = useAuth.getState();
    if (!can("inventory.view") && !can("qc.lot_biography"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { lotId } = Route.useParams();
  return <LotBiographyPage key={lotId} lotId={Number(lotId)} />;
}
